import { LoadingButton } from '@mui/lab';
import { Box, Button, Chip, Divider, Stack, Typography } from '@mui/material';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';

const CartProductCard = ({ product, canMutate, actionLoading, onRemove }) => {
  return (
    <OperationProductCard
      product={product}
      canMutate={Boolean(canMutate)}
      actionLabel={canMutate ? 'حذف از سبد' : undefined}
      onAction={() => onRemove?.(product.guid)}
      actionDisabled={actionLoading}
    />
  );
};

export const ShoppingCartDetail = ({
  cart,
  canMutate = false,
  actionLoading = false,
  onRemoveProduct,
  onRunTask,
  onDeleteCart,
}) => {
  const products = cart?.productPackagingList ?? [];
  const locked = Boolean(cart?.isLocked);
  const canDeleteCart = canMutate && products.length === 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
      >
        <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
          <Chip
            size="small"
            color={locked ? 'default' : 'success'}
            label={locked ? 'قفل شده' : 'فعال'}
          />
          <Divider orientation="vertical" flexItem />
          {cart?.section ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                مقصد
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {cart.section}
              </Typography>
            </Box>
          ) : null}

          <Divider orientation="vertical" flexItem />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="body2" color="text.secondary" fontWeight={600}>
              {products.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              محصول
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" gap={1}>
          {canDeleteCart ? (
            <Button
              size="small"
              color="error"
              variant="outlined"
              disabled={actionLoading}
              onClick={() => onDeleteCart?.(cart.guid)}
            >
              حذف سبد
            </Button>
          ) : null}
          {canMutate && !locked ? (
            <LoadingButton
              size="small"
              variant="contained"
              loading={actionLoading}
              onClick={() => onRunTask?.(cart.guid)}
            >
              ارسال برای چیدمان
            </LoadingButton>
          ) : null}
        </Stack>
      </Stack>

      {products.length === 0 ? (
        <Box
          sx={{
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography color="text.secondary">
            محصولی در این سبد نیست.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              xl: 'repeat(4, 1fr)',
            },
            gap: 2,
          }}
        >
          {products.map(product => (
            <CartProductCard
              key={product.guid}
              product={product}
              canMutate={canMutate ? !locked : null}
              actionLoading={actionLoading}
              onRemove={onRemoveProduct}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
